import { render, staticRenderFns } from "./VerifyMFA.vue?vue&type=template&id=37318ab8"
import script from "./VerifyMFA.vue?vue&type=script&lang=js"
export * from "./VerifyMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports